import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import {
    Loader,
    Container,
    Content,
    Title,
    MessageCard,
    MarketplaceDashboard,
    MarketplacePurchaseFlow,
    i18n,
    tokens
} from '@simplybenefits/sb-ui-library';
import { downloadPDFToBrowser } from '../../services/helpers.js';
import { getInvoice } from '../../actions/invoices.js';
import { getProduct, purchaseProduct, blockProductCoverage, getRate, terminateProduct } from '../../actions/marketplace.js';

class Marketplace extends PureComponent {
    state = {
        selectedProduct: null
    };

    /**
     * @param productID
     * @returns {Promise<void>}
     * @private
     */
    _selectProduct = async (productID) => {
        const selectedProduct = await this.props.dispatch(getProduct(productID));
        
        this.setState({
            selectedProduct
        });
    };

    render() {
        const { whitelabel } = this.props;
        const hasBanking = Number(this.props.meta.paymentsSetup) === 1 || Number(this.props.meta.premiumExempt) === 1; // they have banking if they have setup payment method or if they are premium exempt

        return (
            <Container>
                <Content>
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center' }}>
                        <Title title={ i18n.t(tokens.titles.marketplace) } customStyle={{ flex: 1 }} />
                    </div>

                    {
                        !hasBanking &&
                            <MessageCard
                                title={ i18n.t(tokens.titles.noBankingData) }
                                subtitle={ i18n.t(tokens.labels.dashboard.youNoPaymentSetup)}
                                btnName={ i18n.t(tokens.buttons["add banking"]) }
                                btn
                                btnOnClick={() => {
                                    this.props.history.push('/my-account');
                                }}
                                small
                            />
                    }

                    <MarketplaceDashboard
                        isMasterSite={ false }
                        whitelabel={ whitelabel }
                        member={ this.props.meta }
                        hasBanking={ hasBanking }
                        purchasedProducts={ this.props.marketplace.purchasedProducts }
                        availableProducts={ this.props.marketplace.availableProducts }
                        refusedProducts={ this.props.marketplace.refusedProducts }
                        coverageBlocks={ this.props.marketplace.coverageBlocks }
                        invoices={ this.props.invoices || []}
                        selectProduct={ (...params) => this._selectProduct(...params) }
                        getInvoice={ (...params) => this.props.dispatch(getInvoice(...params)) }
                        terminateProduct={ (...params) => this.props.dispatch(terminateProduct(...params)) }
                        downloadPDFToBrowser={ (...params) => downloadPDFToBrowser(...params) }
                        dispatch={ this.props.dispatch }
                    />

                    {
                        this.state.selectedProduct &&
                            <MarketplacePurchaseFlow
                                loading={ this.props.loading }
                                whitelabel={ whitelabel }
                                member={ this.props.meta }
                                selectedProduct={ this.state.selectedProduct }
                                blockProductCoverage={ (...params) => this.props.dispatch(blockProductCoverage(...params)) }
                                purchaseProduct={ (...params) => this.props.dispatch(purchaseProduct(...params)) }
                                getRate={ (...params) => getRate(...params)}
                                onClose={ () => {
                                    this.setState({
                                        selectedProduct: null
                                    });
                                }}
                            />
                    }
                </Content>
            </Container>
        );
    }
}

/**
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    meta: state.user.meta,
    loader: state.loader,
    whitelabel: state.whitelabel,
    invoices: state.invoices.items,
    marketplace: state.marketplace
});

export default connect(mapStateToProps)(Marketplace);